export default __webpack_public_path__ + "static/media/grocery3.e3891094.jpg";